import { ContainerListPage } from '../../../../../../components/List/styles';
import { formatClassificacao } from '../../../../../../utils/formatClassificacao';
import { QualidadeItem } from '../../page';

type TableProps = {
  rows: QualidadeItem[];
  setSelectedRow: (row: QualidadeItem | null) => void;
  setShowModal: (show: boolean) => void;
};

export const Table = ({ rows, setSelectedRow, setShowModal }: TableProps) => {
  return (
    <ContainerListPage>
      <table>
        <thead>
          <tr>
            <th className="list-td-medium">Classificação</th>
            <th className="first-table-th">Matrícula</th>
            <th className="list-td-large">Produtor</th>
            <th className="list-td-large">Propriedade</th>
            <th className="list-td-medium">CPF/CNPJ</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr
              key={row.DFIDCALCANALISE}
              onClick={() => {
                setSelectedRow(row);
                setShowModal(true);
              }}
              style={{
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              <td>{formatClassificacao(row.DFCLASSIFICADO)}</td>
              <td>{row.DFMATRICULA}</td>
              <td>{row.DFNOMEPRODUTOR}</td>
              <td>{row.DFNOMEPROPRIEDADE}</td>
              <td>{row.DFCNPJCPFCEI}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </ContainerListPage>
  );
};
